import { render } from "./EtatProduitsDisponibles.vue?vue&type=template&id=011f8663&scoped=true&ts=true"
import script from "./EtatProduitsDisponibles.vue?vue&type=script&lang=ts"
export * from "./EtatProduitsDisponibles.vue?vue&type=script&lang=ts"

import "./EtatProduitsDisponibles.vue?vue&type=style&index=0&id=011f8663&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-011f8663"]])

export default __exports__